import type React from 'react';
import { FormField, Input, Label } from '@zillow/constellation-10';

type Props = {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  dataTest?: string;
};

export default function SecurityDepositBankNameInput({ dataTest, ...rest }: Props) {
  return (
    <FormField
      required
      label={<Label>Name of deposit bank</Label>}
      control={<Input {...rest} data-test={dataTest} />}
    />
  );
}
